import { type Styles } from '@adornis/ass/style.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { DlaFooterPage } from './dla-footer-page.js';

/**
 * @element dla-privacy
 */
@customElement('dla-privacy')
export class DlaPrivacy extends DlaFooterPage {
  override render() {
    return html`
      <x-flex class="container" h100 space="lg">
        ${this.backButton()}

        <x-h1> Datenschutzerklärung </x-h1>
        <x-text>
          Diese Datenschutzerklärung dient zur Erfüllung der nach Artikel 13 EU DSGVO geforderten Informationspflicht.
          Sie gilt für die Erhebung und Verarbeitung von Daten zum Zeitpunkt der Erhebung bei betroffenen Personen.
        </x-text>

        <x-flex space="md">
          <x-h2> OctiPad </x-h2>
          <x-text>
            <b>OctiPad</b> ist ein von studiumdigitale entwickeltes, kollaboratives Schreibtool, vergleichbar mit
            anderen Tools wie Etherpad. Es ermöglicht den Nutzenden Text-Dokumente zu erstellen und gemeinsam, in
            Echtzeit zu bearbeiten.
          </x-text>

          <x-text>
            Das Schreibtool <b>OctiPad</b> wird im Rahmen eines Forschungsprojektes, welches an der Goethe Universität
            Frankfurt angesiedelt ist, entwickelt und ist freiwillig sowie kostenlos nutzbar. Wegen des
            Forschungshintergrundes verarbeiten wir, neben Daten, welche zur Nutzung und Weiterentwicklung des Tools
            notwendig sind, erhobene Daten zu Forschungszwecken.
          </x-text>
          <x-text>
            Sollten Sie Fragen zu <b>OctiPad</b> oder der Datenverarbeitungen haben, wenden Sie sich bitte an
            <a href="mailto:octipad@studiumdigitale.uni-frankfurt.de">octipad@studiumdigitale.uni-frankfurt.de</a>
          </x-text>
        </x-flex>

        <x-flex space="md">
          <x-h2> Verantwortliche </x-h2>
          <x-flex space="md">
            <x-flex space="xs">
              <x-text bold>Johann Wolfgang Goethe-Universität Frankfurt am Main</x-text>
              <x-flex space="xs" ${css({ marginLeft: this.spacing.md })}>
                <x-text>Theodor-W.-Adorno-Platz 1</x-text>
                <x-text>60323 Frankfurt am Main</x-text>
              </x-flex>
            </x-flex>

            <x-flex space="xs">
              <x-text bold>Postanschrift:</x-text>
              <x-flex space="xs" ${css({ marginLeft: this.spacing.md })}>
                <x-text>Johann Wolfgang Goethe-Universität Frankfurt am Main</x-text>
                <x-text>60629 Frankfurt</x-text>
              </x-flex>
            </x-flex>

            <x-flex space="xs">
              <x-text bold>studiumdigitale – Zentrale eLearning-Einrichtung</x-text>
              <x-flex space="xs" ${css({ marginLeft: this.spacing.md })}>
                <x-text>Eschersheimer Landstr. 155/157</x-text>
                <x-text>60323 Frankfurt am Mai</x-text>
              </x-flex>
            </x-flex>

            <x-flex space="xs" ${css({ marginLeft: this.spacing.md })}>
              <x-text><b>Telefon:</b> +49 (0) 69 / 798-22198</x-text>
              <x-text><b>Telefax:</b> +49 (0) 69 / 798-22195</x-text>
              <x-text><b>E-Mail:</b> info@studiumdigitale.uni-frankfurt.de</x-text>
              <x-text><b>Internet:</b> www.studiumdigitale.uni-frankfurt.de</x-text>
            </x-flex>
          </x-flex>
        </x-flex>

        <x-flex space="md">
          <x-h2>Kontaktdaten der Datenschutzbeauftragten</x-h2>
          <x-flex space="md">
            <x-flex space="xs">
              <x-text bold> Goethe-Universität Frankfurt am Main </x-text>
              <x-text>Die behördlichen Datenschutzbeauftragten</x-text>
              <x-text>Theodor-W.-Adorno-Platz 1</x-text>
              <x-text>60323 Frankfurt am Main</x-text>
            </x-flex>
          </x-flex>
        </x-flex>

        <x-flex space="md">
          <x-h2>Ihre Rechte</x-h2>
          <x-flex space="sm">
            <x-text>
              Sie haben gegenüber der Goethe-Universität folgende Rechte hinsichtlich Ihrer gespeicherten
              personenbezogenen Daten:
            </x-text>
            <ul>
              <li>
                <x-text>
                  Recht auf Auskunft: Sie haben das Recht, Auskunft über die von uns verarbeiteten personenbezogenen
                  Daten zu verlangen.
                </x-text>
              </li>
              <li>
                <x-text>
                  Recht auf Berichtigung oder Löschung: Sie können die Berichtigung unrichtiger oder die Löschung Ihrer
                  personenbezogenen Daten verlangen, sofern keine gesetzliche Aufbewahrungspflicht besteht.
                </x-text>
              </li>
              <li>
                <x-text>
                  Recht auf Einschränkung der Verarbeitung: Sie haben das Recht, die Verarbeitung Ihrer
                  personenbezogenen Daten einzuschränken.
                </x-text>
              </li>
              <li>
                <x-text>
                  Recht auf Widerruf Ihrer Einwilligung: Sie können Ihre einmal erteilte Einwilligung jederzeit
                  widerrufen.
                </x-text>
              </li>
              <li>
                <x-text>
                  Recht auf Widerspruch gegen die Verarbeitung: Sie haben das Recht, Widerspruch gegen die Verarbeitung
                  Ihrer personenbezogenen Daten einzulegen.
                </x-text>
              </li>
              <li>
                <x-text>
                  Recht auf Datenübertragbarkeit: Sie haben das Recht, Ihre personenbezogenen Daten in einem gängigen,
                  strukturierten und maschinenlesbaren Format zu erhalten (ab dem 25. Mai 2018).
                </x-text>
              </li>
            </ul>
            <x-text>
              Zur Geltendmachung dieser Rechte wenden Sie sich bitte an:
              <a href="mailto:datenschutz@studiumdigitale.uni-frankfurt.de"
                >datenschutz@studiumdigitale.uni-frankfurt.de</a
              >
            </x-text>
          </x-flex>
        </x-flex>

        <x-flex space="md">
          <x-h2>Beschwerdemöglichkeiten</x-h2>
          <x-text>
            Sie haben das Recht, sich bei datenschutzrechtlichen Problemen an die zuständige Aufsichtsbehörde zu wenden:
          </x-text>
          <x-text ${css({ marginLeft: this.spacing.md })}>
            <b>Der Hessische Datenschutzbeauftragte</b><br />
            Postfach 3163<br />
            65021 Wiesbaden<br />
            <br />
            <b>Telefon:</b> +49 611 1408 – 0<br />
            <b>Telefax:</b> +49 611 1408 – 611<br />
            <b>Internet:</b>
            <a href="https://datenschutz.hessen.de/über-uns/kontakt">https://datenschutz.hessen.de/über-uns/kontakt</a>
          </x-text>
        </x-flex>

        <x-flex space="md">
          <x-h2>Zweck der Datenverarbeitung</x-h2>
          <x-flex>
            <x-text>Die Verarbeitung Ihrer personenbezogenen Daten erfolgt zu folgenden Zwecken:</x-text>
            <ol>
              <li>
                <x-text
                  ><b>Technisch Notwendige Daten:</b> Um <b>OctiPad</b> und dessen Features verwenden zu können,
                  Dokumente zu speichern, zu verwalten und kollaboratives Arbeiten zu ermöglichen.</x-text
                >
              </li>
              <li>
                <x-text
                  ><b>Sicherheit und Stabilität:</b> Um die Funktionsfähigkeit, Sicherheit und Fehlerbehebung der
                  Plattform zu gewährleisten.</x-text
                >
              </li>
              <li>
                <x-text
                  ><b>Authentifizierung:</b> Zur Bereitstellung einer personalisierten Benutzererfahrung, bietet
                  <b>OctiPad</b> die Möglichkeit zur Erstellung eines persönlichen Benutzerkontos.</x-text
                >
              </li>
              <li>
                <x-text
                  ><b>Forschungs- und Evaluierungszwecke:</b> Um den zugrundeliegenden Forschungszweck, der Verbesserung
                  der digitalen Lehre, zu erforschen, werden anonymisierte Nutzungsdaten verarbeitet.</x-text
                >
              </li>
            </ol>
          </x-flex>
        </x-flex>

        <x-flex space="md">
          <x-h2>Rechtsgrundlagen der Datenverarbeitung</x-h2>
          <x-flex space="sm">
            <x-text>Die Verarbeitung der Daten erfolgt auf Grundlage der folgenden Rechtsgrundlagen:</x-text>
            <ul>
              <li>
                <x-text
                  ><b>Art. 6 Abs. 1 lit. a DSGVO:</b> Verarbeitung auf Grundlage einer Einwilligung, die vor der
                  Datenerhebung von nicht-anonymen Daten eingeholt wird.</x-text
                >
              </li>
              <li>
                <x-text
                  ><b>Art. 6 Abs. 1 lit. b DSGVO:</b> Verarbeitung zur Durchführung eines Vertrages, insbesondere zur
                  Bereitstellung der Funktionen des Tools.</x-text
                >
              </li>
              <li>
                <x-text
                  ><b>Art. 6 Abs. 1 lit. e DSGVO:</b> Verarbeitung zur Wahrung eines öffentlichen Interesses, nämlich
                  die Verbesserung der Lehre und der Lehrangebote der Goethe-Universität.</x-text
                >
              </li>
              <li>
                <x-text
                  ><b>Art. 6 Abs. 1 lit. c DSGVO:</b> Die Erhebung und Verarbeitung personenbezogener Daten der
                  Studierenden erfolgt auf Basis des Hessischen Hochschulgesetzes und der Immatrikulationsverordnung des
                  Landes Hessen.</x-text
                >
              </li>
              <li>
                <x-text
                  ><b>Art. 6 Abs. 1 lit. c DSGVO:</b> Für Beschäftigte der Goethe-Universität erfolgt die Verarbeitung
                  auf Basis beamtenrechtlicher und personalrechtlicher Regelungen, des Hessischen Hochschulgesetzes und
                  des TV-GU.</x-text
                >
              </li>
              <li>
                <x-text
                  ><b>Art. 89 DSGVO insb. §3 und §24 HDSIG:</b> Verarbeitung zur Erfüllung eines wissenschaftlichen
                  Forschungszweckes.</x-text
                >
              </li>
            </ul>
          </x-flex>
        </x-flex>

        <x-flex space="md">
          <x-h2>Art der gespeicherten Daten, Zweck und Rechtsgrundlagen, Löschungsfristen</x-h2>

          <x-h3>Personenbezogene Daten</x-h3>
          <x-text
            >Personenbezogene Daten sind Informationen, die eine natürliche Person identifizierbar machen, wie z. B.
            Namen, E-Mail-Adressen, Matrikelnummern oder Telefonnummern. Dazu zählen auch Daten über Vorlieben, Hobbys,
            Mitgliedschaften oder Informationen über besuchte Webseiten.</x-text
          >

          <x-h3>Zweck und Dauer der Erfassung</x-h3>
          <x-text
            >Wir verarbeiten und speichern Ihre personenbezogenen Daten nur für den Zeitraum, der zur Erfüllung des
            Speicherungszweckes erforderlich ist oder sofern dies in Gesetzen, Satzungen, Ordnungen, Richtlinien oder
            Vorschriften vorgesehen wurde. Nach Wegfall oder Erfüllung des Zwecks werden Ihre personenbezogenen Daten
            gelöscht bzw. gesperrt.</x-text
          >
          <x-text
            >Im Fall der Sperrung erfolgt die Löschung, sofern gesetzliche, satzungsmäßige oder vertragliche
            Aufbewahrungsfristen dem nicht entgegenstehen, kein Grund zu der Annahme besteht, dass eine Löschung Ihre
            schutzwürdigen Interessen beeinträchtigt und eine Löschung wegen der besonderen Art der Speicherung keinen
            unverhältnismäßig hohen Aufwand verursacht.</x-text
          >
        </x-flex>

        <x-flex space="md">
          <x-h3>Zugriffsdaten / Server-Logdateien</x-h3>

          <x-text
            >Beim Zugriff auf die Seiten dieses Webservers werden folgende Daten in den Server-Logfiles
            gespeichert:</x-text
          >
          <ul>
            <li>
              <x-text><b>IP-Adresse</b></x-text>
            </li>
            <li>
              <x-text><b>Datum und Uhrzeit des Zugriffs</b></x-text>
            </li>
            <li>
              <x-text><b>Typ des Client Browsers</b></x-text>
            </li>
            <li>
              <x-text><b>URL der aufgerufenen Seite</b></x-text>
            </li>
            <li>
              <x-text><b>Gegebenenfalls Fehlermeldungen</b></x-text>
            </li>
            <li>
              <x-text><b>Anfragender Provider</b></x-text>
            </li>
          </ul>
          <x-text
            >Diese Daten dienen ausschließlich der Kontrolle der Funktionalität, der Sicherheit und der Fehlerbehebung.
            Die Nutzung basiert auf <b>Art. 6 Abs. 1 lit. e DSGVO</b> und <b>§3</b> sowie
            <b>§8-11 des Hessischen Gesetzes zum Schutz der elektronischen Verwaltung (HITSiG)</b>.</x-text
          >
          <x-text
            >Alle Logdateien werden automatisiert nach spätestens <b>7 Tagen</b> gelöscht. Bei Sicherheitsvorfällen
            können die Daten bis zu <b>90 Tage</b> gespeichert werden (<b>§14 HITSiG</b>).</x-text
          >
        </x-flex>

        ${[this._nutzungsdaten(), this._nutzugsbedingungen(), this._cookies(), this._kontaktaufnahme()]}
      </x-flex>
    `;
  }

  private _nutzungsdaten() {
    const bereitstellung = html`
      <x-flex space="md">
        <x-text ${css({ color: this.colors.accent, fontStyle: 'italic' })}> Bereitstellung des Tools: </x-text>
        <x-flex space="md" ${css({ marginLeft: this.spacing.lg })}>
          <x-flex space="sm">
            <x-text bold>Verarbeitung und Zweck:</x-text>
            <x-flex>
              <x-text
                >Um alle Funktionen von <b>OctiPad</b> bereitstellen zu können verarbeiten wir Ihre Daten in folgender
                Weise:</x-text
              >
            </x-flex>

            <x-flex ${css({ marginLeft: this.spacing.lg })}>
              <x-text bold> Nutzung der Plattform und Schreiben in Pads: </x-text>
              <ul>
                <li>
                  <x-text>
                    <b>Inhaltsdaten:</b> Wir speichern alle Eingaben und Inhalte der einzelnen Pads um diese zur
                    Weiterbearbeitung bereitstellen zu können.
                  </x-text>
                </li>
                <li>
                  <x-text>
                    <b>Nutzungsdaten:</b> Wir erfassen Daten Ihrer Interaktionen mit <b>OctiPad</b>, einschließlich, wie
                    häufig und in welchem Umfang Sie das Tool verwenden (z. B. erstellte Dokumente, bearbeitete
                    Inhalte). Diese Informationen sind notwendig, um die wesentlichen Funktionen des Tools bereitstellen
                    und aufrechterhalten zu können (zB. für die History-Funktion oder der Erstellung des
                    personalisierten Feedbacks).
                  </x-text>
                </li>
              </ul>
              <x-text bold> Account Erstellung </x-text>
              <ul>
                <li>
                  <x-text>
                    Wenn Sie sich einen Account erstellen, speichern wir Ihre dort angegeben Daten im System
                    (Benutzername, Email, Passwort als Hashwert)
                  </x-text>
                </li>
                <li>
                  <x-text>
                    Wenn Sie <b>OctiPad</b>, eingebunden in ein LMS, wie zB. Moodle nutzen, wird Ihr Account automatisch
                    mit Ihrem LMS-Benutzernamen verknüpft und Ihr Benutzername von dort übernommen.
                  </x-text>
                </li>
                <li>
                  <x-text>
                    Sind Sie eingeloggt, werden alle erfassten Daten mit diesem Benutzernamen verknüpft.
                  </x-text>
                </li>
                <li>
                  <x-text>
                    Sind Sie nicht eingeloggt, werden die erfassten Daten anonym, mit Ihrer temporären Session ID,
                    verknüpft.
                  </x-text>
                </li>
              </ul>
              <x-text bold> History-Funktion </x-text>
              <ul>
                <li>
                  <x-text>
                    In der History eines Dokuments können die einzelnen Bearbeitungsschritte nachverfolgt und ggf.
                    rückgängig gemacht werden.
                  </x-text>
                </li>
                <li>
                  <x-text>
                    Sind sie eingeloggt werden von Ihnen getätigte Änderungen am Pad in der History mit Ihrem
                    Account-Namen angezeigt.
                    <b
                      >Da alle Pads öffentlich sind, kann jeder, der über den Link zu einem Pad verfügt, die
                      Nutzernamen, welche Änderungen am Dokument getätigt haben, einsehen.</b
                    >
                  </x-text>
                </li>
              </ul>

              <x-text bold> Kollaborations-Funktion </x-text>
              <ul>
                <li>
                  <x-text>
                    Zur Förderung einer übersichtlicheren Kollaboration, wird aktiven Nutzern im Pad Ihre aktuell aktive
                    Textstelle im Dokument, mit ihrem Nutzernamen, angezeigt.
                  </x-text>
                </li>
                <li>
                  <x-text>
                    Sind sie eingeloggt, werden Sie an der aktiven Textstelle mit ihrem Account-Namen angezeigt. Da alle
                    Pads öffentlich sind, kann jeder, der über den Link zu einem Pad verfügt, die Nutzernamen über der
                    aktiven Textstelle einsehen.
                  </x-text>
                </li>
              </ul>

              <x-text bold> Feedback-Funktion </x-text>
              <ul>
                <li>
                  <x-text>
                    Wird <b>OctiPad</b>, in einem LMS eingebunden, eingesetzt, werden die erhobenen Daten des
                    Schreibprozesses dafür verwendet, personalisiertes FEEDBACK zum kollaborativen Schreibprozess zu
                    generieren.
                  </x-text>
                </li>
                <li>
                  <x-text>
                    Die Generierung des Feedbacks ist zentraler Bestandteil der angeschlossenen Forschungsvorhaben und
                    befindet sich in einem experimentellen Stadium.
                  </x-text>
                </li>
                <li>
                  <x-text>
                    Die Berechnung des Feedbacks und der dazu benötigten Indikatoren findet mit anonymisierten Daten,
                    auf angeschlossenen Servern statt.
                  </x-text>
                </li>
                <li>
                  <x-text>
                    Das generierte Feedback wird in das LMS zurückgespielt, um dort angezeigt werden zu können.
                  </x-text>
                </li>
              </ul>
            </x-flex>
          </x-flex>

          <x-flex space="sm">
            <x-text bold> Löschfrist: </x-text>
            <x-text>
              Diese Daten werden, solange der Dienst angeboten wird, gespeichert. Werden Pads gelöscht, bleibt Ihre
              History erhalten.
              <b
                >Wenn Sie eine komplette Löschung eines Pads oder eines Accounts wünschen, wenden Sie sich bitte an
                octipad@studiumdigitale.uni-frankfurt.de .</b
              >
            </x-text>
          </x-flex>

          <x-flex space="sm">
            <x-text bold> Rechtsgrundlage: </x-text>
            <x-text>
              Die Erhebung und Verarbeitung dieser Daten erfolgt auf Rechtsgrundlage:
              <b>Rrt. 6 Abs. 1 lit. a DSGVO</b> (Verarbeitung auf Grundlage einer Einwilligung) und
              <b>Art. 6 Abs. 1 lit. b DSGVO</b> (Verarbeitung zur Erfüllung eines Vertrages, insbesondere zur
              Bereitstellung der Funktionen des Tools).
            </x-text>
          </x-flex>
        </x-flex>
      </x-flex>
    `;

    const wartung = html`
      <x-text ${css({ color: this.colors.accent, fontStyle: 'italic' })}> Wartung und Verbesserung: </x-text>
      <x-flex space="md" ${css({ marginLeft: this.spacing.lg })}>
        <x-flex space="sm">
          <x-text bold> Verarbeitung und Zweck: </x-text>
          <x-text>
            Um die Qualität und Funktionalität von <b>OctiPad</b> zu gewährleisten, werden aus den erfassten Daten,
            anonyme, aggregierte Daten abgeleitet sowie gegebenenfalls zusätzliche anonyme Nutzungsdaten erhoben (zB. zu
            den besuchten Seiten, der Zugriffshäufigkeit oder den genutzten Funktionen). Diese Daten helfen uns, das
            Nutzererlebnis zu optimieren und technische Probleme zu identifizieren und zu beheben.
          </x-text>
        </x-flex>

        <x-flex space="sm">
          <x-text bold> Löschfrist: </x-text>
          <x-text>
            Diese anonymen, statistischen Daten werden, solange der Dienst angeboten wird, gespeichert. Eine Löschung
            Ihrer Daten aus diesen Datensätzen ist aufgrund der getätigten Anonymisierung nicht mehr möglich.
          </x-text>
        </x-flex>

        <x-flex>
          <x-flex space="sm">
            <x-text bold> Rechtsgrundlage: </x-text>
            <x-text> Die Erhebung und Verarbeitung dieser Daten erfolgt auf Basis der Rechtsgrundlagen: </x-text>
          </x-flex>
          <ul>
            <li>
              <x-text>
                <b>Art. 6 Abs. 1 lit. b DSGVO</b> (Verarbeitung zur Erfüllung eines Vertrages, insbesondere zur
                Bereitstellung der Funktionen des Tools)
              </x-text>
            </li>
            <li>
              <x-text>
                <b>Art. 6 Abs. 1 lit. e DSGVO:</b> Verarbeitung zur Wahrung eines öffentlichen Interesses, insbesondere
                zur Verbesserung der Lehre.
              </x-text>
            </li>
          </ul>
        </x-flex>
      </x-flex>
    `;

    const forschungszwecke = html`
      <x-text ${css({ color: this.colors.accent, fontStyle: 'italic' })}> Forschungszwecke: </x-text>
      <x-flex space="md" ${css({ marginLeft: this.spacing.lg })}>
        <x-flex space="sm">
          <x-flex space="sm">
            <x-text bold> Verarbeitung und Zweck: </x-text>
            <x-text>
              Teile, der zum Betrieb und zur Weiterentwicklung erfassten Daten, werden vollständig anonymisiert zu
              wissenschaftlichen Forschungszwecken aufbereitet. Dies dient dazu Erkenntnisse zur Nutzung des Tools in
              Lehr-Lernkontexten zu erforschen und Anhaltspunkte zur Verbesserung der Lehre und Lehrmethoden zu
              gewinnen.
            </x-text>
          </x-flex>
        </x-flex>

        <x-flex space="sm">
          <x-text>
            <b>
              Die anonymisierten Daten können in veröffentlichten Forschungsergebnissen enthalten sein und unter
              Umständen an Dritte weitergegeben werden.
            </b>
            Der Schutz Ihrer personenbezogenen Daten ist dabei stets gewährleistet und es ist den Forschenden zu keiner
            Zeit möglich Rückschlüsse auf Ihre Person zu machen.
          </x-text>
        </x-flex>

        <x-flex space="sm">
          <x-text bold> Löschfrist: </x-text>
          <x-text>
            Im Sinne der Regeln guter wissenschaftlicher Praxis der Deutschen Forschungsgemeinschaft, werden die
            anonymisierten Daten mindestens 10 Jahre von studiumdigitale aufbewahrt. Außerdem kann es kann zu einer
            Weitergabe der anonymisierten Daten an Dritte (zB. weitere ForscherInnen und Institutionen) kommen. Eine
            Löschung Ihrer Daten aus diesen Datensätzen ist aufgrund der getätigten Anonymisierung nicht mehr möglich.
          </x-text>
        </x-flex>

        <x-flex space="sm">
          <x-text bold> Rechtsgrundlage: </x-text>
          <x-text>
            Die Verarbeitung zu Forschungszwecken erfolgt auf Grundlage von EU DSGVO Artikel 89 (wissenschaftliche
            Zwecke) sowie §3 und §24 HDSIG (Hessisches Datenschutz- und Informationsfreiheitsgesetz). Die rechtliche
            Grundlage ist insbesondere die IuK-Nutzungsordnung der Goethe-Universität.
          </x-text>
        </x-flex>
      </x-flex>
    `;

    return html`
      <x-flex space="md">
        <x-h2>Nutzungsdaten - Verarbeitungen während der Nutzung von <b>OctiPad</b></x-h2>
        <x-flex>
          <x-text
            >Das Schreibtool <b>OctiPad</b> wird im Rahmen eines Forschungsprojektes entwickelt und ist freiwillig sowie
            kostenlos nutzbar. Wegen des Forschungshintergrundes erheben wir, neben Daten, welche zur Nutzung und
            Weiterentwicklung des Tools notwendig sind, Daten zu Forschungszwecken.</x-text
          >
        </x-flex>

        <x-flex space="md">
          <x-h2>Erhebung und Verarbeitung der Nutzungsdaten</x-h2>
          <x-text
            >Zur Bereitstellung und Erreichung unserer Ziele werden Nutzungsdaten, welche bei der Verwendung von
            <b>OctiPad</b> anfallen, erhoben die folgende Zwecke verfolgen:</x-text
          >
        </x-flex>

        ${[bereitstellung, wartung, forschungszwecke]}
      </x-flex>
    `;
  }

  private _nutzugsbedingungen() {
    return html`
      <x-flex space="md">
        <x-h2> Nutzungsbedingungen - Verantwortung der Nutzer </x-h2>

        <x-flex>
          <x-text>
            Die Verarbeitung von Daten, die während der Nutzung von OctiPad im Schreibprozess entstehen (Pads), obliegt
            der Verantwortung der Nutzenden und basiert auf Freiwilligkeit.
          </x-text>
          <ul>
            <li>
              <x-text>
                Jede/r Nutzer/in ist verantwortlich für die rechtmäßige Verarbeitung dieser Daten, insbesondere wenn es
                um die Einhaltung der Datenschutzbestimmungen bezüglich der Rechte Dritter geht.
              </x-text>
            </li>
            <li>
              <x-text>
                Für die Einhaltung von anderen Rechtsvorschriften (Urheberrecht, Persönlichkeitsrechte, etc) sind die
                Nutzenden selbst verantwortlich.
              </x-text>
            </li>
            <li>
              <x-text>
                Bitte informieren Sie uns umgehend über eventuellen Missbrauch oder unbefugten Zugriff, indem Sie eine
                Mitteilung an octipad@studiumdigitale.uni-frankfurt.de senden.
              </x-text>
            </li>
            <li>
              <x-text>
                Sollten Daten weiterer Personen betroffen sein, obliegt die Einhaltung der datenschutzrechtlichen
                Bestimmungen den für die Nutzung Verantwortlichen. Alle Nutzenden können die Pads exportieren und sind
                für die rechtmäßige Weiterverarbeitung und Speicherung der Daten selbst verantwortlich.
              </x-text>
            </li>
            <li>
              <x-text>
                Nutzende sind dafür verantwortlich, bei der Erhebung personenbezogener Daten über die geplante
                Datenverarbeitung zu informieren und eine geeignete Rechtsgrundlage zu prüfen. Sie müssen sicherstellen,
                dass in ihren Dokumenten die Rechte der Betroffenen und die Löschfristen eingehalten werden.
              </x-text>
            </li>
            <li>
              <x-text>
                Der Dienst unterliegt grundsätzlich keiner inhaltlichen Kontrolle durch die Systembetreuung von
                studiumdigitale. Wir behalten uns vor, Einträge zu löschen und Maßnahmen zu ergreifen, wenn Einträge
                strafrechtlich relevante Tatbestände erfüllen oder mit den Zielen der IuK-Nutzungsordnung der
                Goethe-Universität nicht zu vereinbaren sind.
              </x-text>
            </li>
          </ul>
        </x-flex>
      </x-flex>
    `;
  }

  private _cookies() {
    return html`
      <x-flex space="md">
        <x-h2> Cookies </x-h2>

        <x-text>
          Wir verwenden Cookies. Cookies sind kleine Dateien, die im Rahmen Ihres Besuchs unserer Webseite von uns an
          den Browser Ihres Endgeräts gesendet und dort gespeichert werden. Einige Funktionen unserer Webseite können
          ohne den Einsatz technisch notwendiger Cookies nicht angeboten werden.
        </x-text>
        <x-text>
          Wir verwenden Cookies, um die Benutzung unserer Webseite zu erleichtern und zu verbessern. So können wir durch
          Cookies unter anderem unser Internetangebot für Sie nutzerfreundlicher und effektiver gestalten, indem wir
          Ihre Nutzung unserer Webseite nachvollziehen und Ihre bevorzugten Einstellungen (z. B. Länder- und
          Spracheinstellungen) feststellen. Cookies richten auf Ihrem Endgerät keinen Schaden an. Sie können keine
          Programme ausführen und keine Viren enthalten.
        </x-text>
        <x-text>
          Die von uns verwendeten Cookies sind ausschließlich technisch notwendige Cookies. Ohne diese Cookies ist die
          Nutzung unserer Webseite nicht möglich. Es findet keine Weitergabe Ihrer Cookie-Daten an Dritte statt.
          Rechtsgrundlage für die Speicherung der Cookies ist § 25 Abs. 2 Nr. 2 TTDSG.
        </x-text>

        <x-flex space="md">
          <x-text> Übersicht über die verwendeten Cookies </x-text>
          <x-grid
            space="xs"
            columns="1fr 1fr 1fr"
            ${css({ padding: this.spacing.xs, border: `1px solid ${this.colors.neutral.shade(50)}` })}
          >
            <x-text bold>Name (Cookie-Name)</x-text>
            <x-text bold>Zweck</x-text>
            <x-text bold>Laufzeit</x-text>

            <x-hr ${css({ gridColumn: '1 / -1' })}></x-hr>

            <x-text bold>LOCALE</x-text>
            <x-text>Speicherung der für OctiPad genutzten Spracheinstellung</x-text>
            <x-text>1 Monat</x-text>

            <x-hr ${css({ gridColumn: '1 / -1' })}></x-hr>

            <x-text bold>PHPSESSID</x-text>
            <x-text>Speicherung einer eindeutigen ID zur Wiedererkennung des Nutzers</x-text>
            <x-text>Dauer der Sitzung</x-text>

            <x-hr ${css({ gridColumn: '1 / -1' })}></x-hr>

            <x-text bold> accepted_legal </x-text>
            <x-text> Speicherung der Auswahl zur Zustimmung der Datenschutzerklärung </x-text>
            <x-text> Dauerhaft </x-text>
          </x-grid>
        </x-flex>

        <x-flex>
          <x-text>
            Zusätzlich zu Cookies verwenden wir folgende Technologien zur Speicherung bestimmter Daten in Ihrem Browser:
          </x-text>
          <ul>
            <li>
              <x-text>
                <b>Local Storage:</b> Speicherung von Einstellungen für eine nutzerfreundliche Anwendung.
              </x-text>
            </li>
            <li>
              <x-text>
                <b>Session Storage:</b> Speicherung von Sitzungsinformationen, die nach Beendigung der Sitzung gelöscht
                werden.
              </x-text>
            </li>
            <li>
              <x-text>
                <b>IndexedDB:</b> Zur Verwaltung von umfangreicheren Datensätzen, die für eine reibungslose Interaktion
                mit dem Tool erforderlich sind.
              </x-text>
            </li>
          </ul>
          <x-text>
            Eine Datenweitergabe an Dritte findet nicht statt. Die Verarbeitung findet aufgrund ihrer technischen
            Notwendigkeit auf der Grundlage von § 25 Abs. 2 Nr. 2 TTDSG statt.
          </x-text>
        </x-flex>
      </x-flex>
    `;
  }

  private _kontaktaufnahme() {
    return html`
      <x-flex space="md">
        <x-h2> Kontaktaufnahme </x-h2>
        <x-text>
          Zur Kontaktaufnahme mit Mitgliedern der Goethe-Universität (z. B. per Kontaktformular oder E-Mail) werden Ihre
          Angaben zur Bearbeitung der Anfrage gespeichert und für eventuelle Anschlussfragen aufbewahrt.
        </x-text>
        <x-text>
          Nach Bearbeitung Ihres Anliegens sowie nach Erfüllung der rechtlichen oder vertraglichen Pflichten werden die
          Daten gelöscht, es sei denn, die Aufbewahrung der Daten ist zur Umsetzung berechtigter Interessen der
          Goethe-Universität oder aufgrund gesetzlicher Vorschriften erforderlich (z. B. Gesetze, Rechtsverordnungen,
          Satzungen der Goethe-Universität).
        </x-text>
      </x-flex>
    `;
  }

  override styles() {
    return [
      ...super.styles(),
      {
        ':host': {
          overflowY: 'auto',
        },
        '.container': {
          width: '100%',
          maxWidth: this.sizes.maxReadableWidth,
          margin: '0 auto',
          paddingTop: this.spacing.lg,
          paddingBottom: this.spacing.xl,
        },
        'x-h1': {
          color: this.colors.accent,
        },
        'x-h2': {
          color: this.colors.accent,
        },
        'x-h3': {
          color: this.colors.accent,
        },
        'x-h4': {
          color: this.colors.accent,
        },
        ul: {
          margin: 0,
        },
        ol: {
          margin: 0,
        },
        li: {
          margin: `${this.spacing.sm} 0`,
          fontFamily: 'Maven Pro',
        },
      } as Styles,
    ];
  }
}
